<template>
  <v-container
    fluid
    class="pa-0"
  >
    <v-row
      align="center"
      class="ma-0"
    >
      <v-col
        cols="8"
        class="pa-0 text-truncate d-flex align-center"
      >
        <v-icon
          color="#93be20"
          v-text="$vuetify.icons.values['mdiHexagonOutline']"
          left
          small
        />
        <v-tooltip
          top
        >
          <template v-slot:activator="{on}">
            <v-flex class="d-flex flex-column text-break">
              <span
                class="body-2"
                v-text="displayName"
                v-on="on"
              />
              <span
                class="caption font-weight-light status--text"
                :class="statusClass"
                v-text="statusText"
              />
            </v-flex>
          </template>
          <span v-text="displayName"/>
        </v-tooltip>
      </v-col>
      <v-col
        cols="4"
        class="pa-0"
      >
        <v-row
          class="ma-0"
        >
          <v-spacer/>
          <v-btn-toggle
            v-if="false"
            v-model="isShapeActive"
            rounded
            @change="onShapeActiveChanged"
          >
            <v-btn
              color="accent"
              icon
              small
              elevation="0"
              :value="true"
            >
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
          </v-btn-toggle>
          <v-btn
            color="info"
            :disabled="!postProcessingAnalysisField['json_custom_fields']"
            icon
            small
            @click="toggleInfo"
          >
            <v-icon small v-text="$vuetify.icons.values['mdiAlertCircle']"/>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-expand-transition>
      <v-container
        v-if="isInfoActive"
        fluid
        class="pa-0 ma-0"
      >
        <v-row
          v-for="(item, idx) in postProcessingAnalysisField['json_custom_fields']"
          :key="idx"
          align="center"
          justify="space-between"
          class="ma-0"
        >
          <v-col
            cols="8"
            class="px-0 py-2 text-left"
          >
            <span class="caption font-weight-bold" v-text="item['title']"/>
          </v-col>
          <v-col
            cols="4"
            class="px-0 py-2 text-right text-right"
          >
            <span class="caption" v-text="item['description']"/>
          </v-col>
        </v-row>
      </v-container>
    </v-expand-transition>
  </v-container>
</template>

<script>
  import {PostProcessingsTilesEventBus} from "../../../../helpers/mapview/events"
  import {POST_PROCESSINGS_STATUS_NAMES} from "../../../../helpers/post-processings/constants"

  export default {
    name: "PostProcessingResultAnalysisField",
    props: {
      postProcessingAnalysisField: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      isInfoActive: false,
      isShapeActive: false
    }),
    methods: {
      toggleInfo() {
        this.isInfoActive = !this.isInfoActive
      },
      onShapeActiveChanged(value) {
        if (value) {
          PostProcessingsTilesEventBus.$emit("add", {
            idPostProcessingAnalysisField: this.postProcessingAnalysisField["id_post_processing_analysis_field"],
            field: this.postProcessingAnalysisField["field"]
          })
        } else {
          PostProcessingsTilesEventBus.$emit("remove", {
            idPostProcessingAnalysisField: this.postProcessingAnalysisField["id_post_processing_analysis_field"],
          })
        }
      },
    },
    computed: {
      displayName() {
        if (!this.postProcessingAnalysisField) return ""
        // const idField = this.postProcessingAnalysisField["field"]["id_field"]
        const nmField = this.postProcessingAnalysisField["field"]["nm_field"]
        if (nmField) return nmField
        return ""
      },
      statusText() {
        const abStatus = this.postProcessingAnalysisField['ab_status']
        if (!abStatus) return ""

        const status = POST_PROCESSINGS_STATUS_NAMES[abStatus]
        if (!status) return ""

        return status["text"]
      },
      statusClass() {
        const abStatus = this.postProcessingAnalysisField['ab_status']
        if (!abStatus) return ""

        const status = POST_PROCESSINGS_STATUS_NAMES[abStatus]
        if (!status) return ""

        return status["class"]
      },
    }
  }
</script>

<style scoped>

</style>
